import React from 'react'
import { ErrorMessage, FormikProps } from 'formik'
import { Attributes, Label, Validation } from 'app/modules/tp/builders/FormBuilder';
import CheckboxSwitch from './CheckboxSwitch';
import { traverseKeyObj } from 'app/utils/keys';
import { Actions } from 'app/modules/tp/components/Modal/ModalEntity';

export type CheckboxInput<T> = {
    type: "checkbox",
    key: keyof T,
    isRequired?: boolean,
    attributes?: Attributes
} & Attributes & Validation & Label


export type CheckboxInputFieldProps<T> = {
    formik: FormikProps<T>,
    inputObj: CheckboxInput<T>
    actions: Actions<T>,
    onChange?: (e: T) => void,
}

const CheckboxInputField = <T,>({ formik, inputObj, onChange }: CheckboxInputFieldProps<T>) => {


    const isChecked : boolean = React.useMemo(() => (
        !! formik.getFieldProps(inputObj.key).value
    ), [formik.values, inputObj.key]);

    if(formik.getFieldProps(inputObj.key).value === null){
        formik.setFieldValue(inputObj.key as string, false);
    }

    return (<>
        <div className='mt-3'>
            <CheckboxSwitch
                {...formik.getFieldProps(inputObj.key)}
                type='switch'
                name={`${inputObj.key}` as string}
                checked={(isChecked)}
                onChange={(e: any) => {
                    formik.setFieldValue(inputObj.key as string, e.target.checked);
                    onChange && onChange(formik.values);
                }}
                autoComplete='off'
                disabled={formik?.isSubmitting}
                {...inputObj.attributes}
                label={inputObj.label}
            />
            {formik?.touched[inputObj.key] && formik.errors[inputObj.key] && (
                <ErrorMessage name={inputObj.key as string}
                    render={(error: string) => (
                        <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                                <span role='alert'>{error}</span>
                            </div>
                        </div>
                    )} />
            )}
        </div>

    </>
    )
}
export default CheckboxInputField;
